var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./addressBar", "./jquery-plugins/numberInput", "./number", "./priceFormula", "./renderCustomValance"], function (require, exports, addressBar_1, numberInput_1, number_1, priceFormula_1, renderCustomValance_1) {
    "use strict";
    exports.__esModule = true;
    var defaultSizeSpec = {
        unit: 'inches',
        shortUnit: '"',
        attrId: 0,
        isMobile: $('body').hasClass('env-phone'),
        visible: true
    };
    exports.curtainSizeSpecs = {
        valanceWidth: {
            min: 35,
            max: 200,
            step: 1,
            attrName: 'width',
            id: 'valanceWidth',
            label: 'Valance width',
            defaultVal: 70
        },
        panelWidth: {
            min: 35,
            max: 200,
            step: 1,
            attrName: 'panelWidth',
            id: 'panelWidth',
            label: 'Panel width',
            defaultVal: 70
        },
        panelHeight: {
            min: 60,
            max: 210,
            step: 1,
            attrName: 'height',
            id: 'panelHeight',
            label: 'Panel height',
            defaultVal: 96
        },
        sideValanceWidth: {
            min: 35,
            max: 200,
            step: 1,
            attrName: 'sideWidth',
            id: 'sideValanceWidth',
            label: function () {
                return isSwagOverPanel() ? 'Side window width' :
                    (hasValance(number_1.extractFieldAsDecimal($('#custom_product_select input[type="hidden"]'))) ? 'Side valance width' : 'Side panel width');
            },
            defaultVal: 40
        }
    };
    exports.fromStyleIndexToSizSpec = function (styleIndex) {
        if (styleIndex === renderCustomValance_1.StyleEnum.PanelWithSwag) {
            return {
                panelWidth: __assign({}, exports.curtainSizeSpecs.panelWidth, { min: 70, max: 70, step: 0, defaultVal: 70 }),
                valanceWidth: __assign({}, exports.curtainSizeSpecs.valanceWidth, { min: 35, max: 35, step: 0, defaultVal: 35 }),
                panelHeight: __assign({}, exports.curtainSizeSpecs.panelHeight),
                sideValanceWidth: __assign({}, exports.curtainSizeSpecs.sideValanceWidth, { min: 35, max: 35, step: 0, defaultVal: 35 })
            };
        }
        return exports.curtainSizeSpecs;
    };
    exports.sizeSpec = function (kind) { return function (initialVal) {
        var _size = exports.curtainSizeSpecs[kind];
        return __assign({}, defaultSizeSpec, _size, { initialVal: exports.val(initialVal) || _size.defaultVal });
    }; };
    exports.isCalc = function (x) { return typeof x === 'function'; };
    exports.val = function (x) { return exports.isCalc(x) ? x() : x; };
    exports.renderInput = function (spec, value) {
        var result = [];
        var min = spec.min, max = spec.max, step = spec.step, unit = spec.unit, id = spec.id, attrName = spec.attrName, attrId = spec.attrId;
        result.push("<label for='" + spec.id + "'>" + exports.val(spec.label) + ":</label>");
        result.push("<input type='number' name='" + attrName + "' id='" + id + "' min='" + min + "' max='" + max + "' step='" + step + "' value='" + value + "' data-check-range data-attribute-name='" + attrName + "' data-attribute-id='" + attrId + "'/>");
        result.push("<span>" + unit + "</span>");
        return result;
    };
    exports.renderRange = function (spec, value) {
        var result = [];
        var min = spec.min, max = spec.max, step = spec.step, id = spec.id, unit = spec.shortUnit, attrName = spec.attrName, attrId = spec.attrId;
        result.push('<div>');
        result.push("<label for='" + spec.id + "'>" + exports.val(spec.label) + ":</label>");
        result.push("<span data-sync='" + id + "'>" + value + "</span>");
        result.push("<span>" + unit + "</span>");
        result.push('</div>');
        result.push("<button class='circle' type='button'>-</button>");
        result.push("<input type='range' name='" + attrName + "' id='" + id + "' min='" + min + "' max='" + max + "' step='" + (step || 1) + "' value='" + value + "' data-attribute-name='" + attrName + "' data-attribute-id='" + attrId + "'/>");
        result.push("<button class='circle' type='button'>+</button>");
        return result;
    };
    exports.updateSizeSpecs = function ($specs, style) {
        var specs = exports.fromStyleIndexToSizSpec(style);
        $specs.each(function (_, spec) {
            var $spec = $(spec);
            var kind = $spec.data('sizespec');
            var sizeSpec = __assign({}, defaultSizeSpec, specs[kind]);
            var shouldDisplay = sizeSpec.step > 0;
            var $input = $spec.find('input');
            var $controls = $spec.find('input, button');
            var curVal = number_1.valAsNumber($input.val());
            if (!shouldDisplay) {
                $input.attr({ min: sizeSpec.min, max: sizeSpec.max });
                number_1.setFieldNumberVal($input, sizeSpec.defaultVal).trigger('input');
            }
            else {
                var valid = curVal >= sizeSpec.min && curVal <= sizeSpec.max;
                $input.attr({ min: sizeSpec.min, max: sizeSpec.max });
                if (!valid) {
                    number_1.setFieldNumberVal($input, sizeSpec.defaultVal).trigger('input');
                }
            }
            if (exports.val(sizeSpec.isMobile)) {
                $controls.toggleClass('hidden', !shouldDisplay);
            }
            if (shouldDisplay) {
                $input.removeProp('disabled');
            }
            else {
                $input.prop('disabled', 'disabled');
            }
        });
    };
    var setSizeSpecVal = function ($spec, val) {
        var $input = $spec.find('input');
        number_1.setFieldNumberVal($input, val);
        if ($input.attr('type') === 'range') {
            $input.trigger('input');
        }
        else {
            $input.trigger('change');
        }
        return $spec;
    };
    var syncTargetSizeSpec = function ($spec) {
        var syncTarget = $spec.data('synctarget');
        if (syncTarget) {
            var $syncTarget = $("div[data-sizespec=\"" + syncTarget + "\"]");
            if ($syncTarget.length) {
                var size = number_1.valAsNumber($spec.find('input').val());
                var max = number_1.valAsNumber($syncTarget.data('syncmax') || size);
                setSizeSpecVal($syncTarget, Math.min(size, max));
            }
            if ($spec.data('sizespec') == 'valanceWidth') {
                var $sideValanceWidth = $('div[data-sizespec="sideValanceWidth"');
                var size = number_1.valAsNumber($spec.find('input').val());
                setSizeSpecVal($sideValanceWidth, Math.max(size / 2, 35));
            }
        }
        return $spec;
    };
    exports.renderSizeSpec = function ($div, spec) {
        var initialVal = exports.val(spec.initialVal);
        var result = [];
        result.push.apply(result, (!spec.isMobile ? exports.renderInput(spec, initialVal) : exports.renderRange(spec, initialVal)));
        $div.append(result.join(''));
        $div.find('input[type="range"]').on('input', function (e) {
            var $range = $(e.currentTarget);
            $div.find("span[data-sync='" + $range.attr('id') + "']").text($range.val());
            syncTargetSizeSpec($div);
        });
        $div.find('input[type="number"]').on('change', function (e) {
            numberInput_1.validateNumberRange($(e.currentTarget));
            syncTargetSizeSpec($div);
        });
        $div.find('button').on('click', function (e) {
            var $button = $(e.currentTarget);
            var $range = $button.parent().find('input[type="range"]');
            var step = parseInt($range.attr('step'), 10);
            var direction = $button.text() === '+' ? 1 : -1;
            var curVal = parseInt($range.val(), 10);
            var nextVal = Math.min(spec.max, Math.max(spec.min, curVal + step * direction));
            if (nextVal !== curVal) {
                $range.val(nextVal).trigger('input').trigger('change');
            }
        }).dblclick(function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        return;
    };
    exports.hasPanel = function (p) { return p === renderCustomValance_1.ProductType.FullSet || p === renderCustomValance_1.ProductType.DrapeOnly; };
    var hasValance = function (p) { return p === renderCustomValance_1.ProductType.ValanceOnly || p === renderCustomValance_1.ProductType.FullSet; };
    var hasSideWindow = function (w) { return w === renderCustomValance_1.WindowType.BayWindow; };
    var getStyleIndex = function () { return parseInt($('#custom_style_select input[data-attribute-name="styleIndex"]').val()); };
    var isSwagOverPanel = function () { return getStyleIndex() === renderCustomValance_1.StyleEnum.PanelWithSwag; };
    var handleProductTypeChange = function ($specs, productType, windowType) {
        $specs.each(function (_, s) {
            var $s = $(s);
            var kind = $s.data('sizespec');
            switch (kind) {
                case 'panelHeight':
                    $s.toggleClass('hidden', !exports.hasPanel(productType));
                    break;
                case 'sideValanceWidth':
                    $s.toggleClass('hidden', !hasSideWindow(windowType));
                    $s.find('label[for="sideValanceWidth"]').text(exports.val(exports.curtainSizeSpecs[kind].label));
                    break;
                case 'panelWidth':
                    $s.toggleClass('hidden', !exports.hasPanel(productType) || hasValance(productType));
                    break;
                case 'valanceWidth':
                    $s.toggleClass('hidden', !hasValance(productType));
                    break;
                default:
                    break;
            }
        });
        $('#panel7').toggleClass('hidden', !exports.hasPanel(productType));
    };
    exports.initialize = function ($specs, $productType, $windowType) {
        var attrs = __assign({}, priceFormula_1.getAttributesFromForm(true, number_1.extractFieldAsDecimal($productType)), addressBar_1.getAttributesFromHash());
        var initialValues = {
            valanceWidth: attrs.width,
            panelHeight: attrs.height,
            panelWidth: attrs.panelWidth,
            sideValanceWidth: attrs.sideWidth
        };
        var getWindowType = function () { return number_1.extractFieldAsDecimal($windowType); };
        var getProductType = function () { return number_1.extractFieldAsDecimal($productType); };
        $specs.each(function (_, spec) {
            var kind = $(spec).data('sizespec');
            var curtainSizeSpec = exports.sizeSpec(kind)(initialValues[kind]);
            exports.renderSizeSpec($(spec), curtainSizeSpec);
        });
        $productType.add($windowType).on('change', function (e) {
            var productType = getProductType();
            handleProductTypeChange($specs, productType, getWindowType());
        });
        handleProductTypeChange($specs, number_1.extractFieldAsDecimal($productType), getWindowType());
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/curtainSizeSpec.js
// module id = 54
// module chunks = 0